export const mockData: any = {
  faqList: [
    {
      sNo: "01",
      question: "How could AI support energy efficiency?",
    },
    {
      sNo: "02",
      question: "What is the investment trend in infrastructure for the year 2024?",
    },
    {
      sNo: "03",
      question: "What are the recommendations for ESG tools in 2024?",
    },
    {
      sNo: "04",
      question: "Please provide me with a step-by-step green building assessment.",
    },
    {
      sNo: "05",
      question: "How can IoT be enabled in green buildings?",
    }
  ],
};
